(function ($, window) {
    "use strict";
    var animateInTimer,
        mobileScrollThrottled;
    DSV.ui.scroll = {
        scrollFunctions: [],
        totalFunctions: 0,
        throttleTimer: null,
        position: 0,
        menuTop: DSV.DOM.header.lenght ? DSV.DOM.header && DSV.DOM.header.offset().top : "",

        /* Get various window sizes - width, height etc. - and store them on our prototype. */
        getScrollPosition: function(e) {
            DSV.ui.scroll.position = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
        },

        /* This function is run every time the window is resized. It's on a throttle, though, so it won't be fired too often. */
        runScrollFunctions: function() {
            var i,
                total = DSV.ui.scroll.scrollFunctions.length;

            // Get our current window size(s)
            DSV.ui.scroll.getScrollPosition();
            // Fire all queued functions that other scripts may have registered.
            for (i = 0; i < total; i++) {
                DSV.ui.scroll.scrollFunctions[i]();
            }
        },
        onScrollMobile: function(){
            DSV.ui.scroll.runScrollFunctions();
            if(DSV.ui.scroll.position < DSV.ui.scroll.menuTop){
                DSV.DOM.window.off("scroll", mobileScrollThrottled);
                DSV.DOM.window.on("touchend", function(){
                    clearTimeout(animateInTimer);
                    animateInTimer = setTimeout(DSV.ui.scroll.animateInElements, 1500);
                });
            }
        },
        animateInElements: function () {
            mobileScrollThrottled = DSV.tools.throttle(DSV.ui.scroll.onScrollMobile, 15);
            DSV.ui.scroll.runScrollFunctions();
            if(DSV.ui.scroll.position >= DSV.ui.scroll.menuTop) {
                DSV.DOM.window.off("touchend");
                DSV.DOM.window.on("scroll", mobileScrollThrottled);
            }
        },
        init: function(){
            var selfScope = this;

            if(Modernizr.touchevents){
                DSV.DOM.window.on("touchend", function(){
                    clearTimeout(animateInTimer);
                    animateInTimer = setTimeout(DSV.ui.scroll.animateInElements, 1300);
                });
            } else {
                DSV.DOM.window.on("scroll", DSV.tools.throttle(selfScope.runScrollFunctions, 16));
            }
            setTimeout(selfScope.runScrollFunctions, 1300);
        }
    };
})(jQuery, window);